import React from 'react'
import Fade from 'react-reveal/Fade'
import styled from 'styled-components'

import BaseLayout from 'components/Layout/Base'
import ResponsiveContainer from 'components/utils/ResponsiveContainer'

import { TextVampiroOne, TextMinecraft, TextArkEs } from 'components/utils/FontSpan'
import LogoAbout from 'images/logo-about.inline.svg'
import bgImage from 'images/bg-page-about.jpg'

const About = ({ location }) => {

    const Background = () => {
        return (
            <BackgroundContainer className="w-full h-full "></BackgroundContainer>
        )
    }
    return (
        <BaseLayout pageTitle="About" location={ location } background={<Background />} footerButtonColor="#9D1C8F" solidFooter={ true }>
            <section>
                <ResponsiveContainer className="py-16 md:py-24">
                    <div className="lg:w-10/12 lg:mx-auto">
                        <Fade>
                            <h2 className="text-3xl mb-8 lg:text-5xl"><TextVampiroOne>A</TextVampiroOne>bout <TextMinecraft>I</TextMinecraft>deafest</h2>
                            <div className="flex flex-col sm:flex-row sm:space-x-12 sm:items-start md:space-x-24">
                                <div className="order-2 sm:order-1">
                                    <p>Ideafest is the biggest creative festival in Indonesia where disruptive and trendsetting individuals share, discuss, and provoke fresh and insightful ideas. In its tenth anniversary, Ideafest is set to become a creative hub where all stakeholders in the creative industry gather to grow budding talents and build an ecosystem that could weather whatever the future might bring.</p>
                                    <p>Ideafest believes that collaboration is the way forward. By spotlighting the latest insights and bringing together people from multi-creative disciplines in one collaborative avenue, Ideafest enables everyone to share, connect, and learn from each other to scale up their initiatives so we can move towards an inclusive future.</p>
                                </div>
                                <div className="order-1 mb-8 sm:order-2 sm:mb-0">
                                    <LogoAbout className="w-40 h-auto mx-auto block sm:w-52 sm:-mt-3 md:w-64 md:-mt-4" />
                                </div>
                            </div>
                        </Fade>
                    </div>
                </ResponsiveContainer>
            </section>
            <section>
                <ResponsiveContainer>
                    <div className="grid grid-cols-1 gap-8 sm:grid-cols-2">
                        <Fade>
                            <div>
                                <h3 className="text-3xl mb-8 lg:text-5xl"><TextVampiroOne>I</TextVampiroOne>deaFest <TextVampiroOne>M</TextVampiroOne>ission</h3>
                                <p>Ideafest aims to bring people from multi-creative disciplines together in one virtual hub. Creating an inclusive space where they can converse and inspire each other without limitations, paving the way for groundbreaking ideas that will shape the future.</p>
                            </div>
                            <div>
                                <h3 className="text-3xl mb-8 lg:text-5xl"><TextVampiroOne>I</TextVampiroOne>deaFest <TextArkEs>V</TextArkEs>ision</h3>
                                <p>Ideafest exists to be a creative haven that connects and empower the nation’s creative communities, so they can unleash their growth potentials and go beyond what’s possible.</p>
                            </div>
                        </Fade>
                    </div>
                </ResponsiveContainer>
            </section>
            <hr className="container mx-auto border-0 border-b border-white border-solid h-0 my-16" />
            <section>
                <ResponsiveContainer className="pb-16 lg:pb-24">
                    <Fade>
                        <h3 className="text-3xl mb-8 lg:text-5xl"><TextVampiroOne>H</TextVampiroOne>int of <TextArkEs>I</TextArkEs>deaFest <TextMinecraft>2</TextMinecraft>021 <TextVampiroOne>T</TextVampiroOne>heme</h3>
                        <p>The x-factor might stand for an uncertain future that might throw a wrench into our plan, but it also stands for the unlimited possibilities that enable us to go where no one has gone before. Ideafest invites you to look at the x-factor in a new light, embracing the unknown and harnessing its power to map out the uncharted territory of the future. This year, let’s discover how the x-factor can empower you.</p>
                    </Fade>
                </ResponsiveContainer>
            </section>
        </BaseLayout>
    )
}

const BackgroundContainer = styled.div`
    background-image: url(${ bgImage });
    background-position: center;
    background-size: cover;
`

export default About
